import isArray from "lodash-es/isArray";
import { parse as parseQs, stringify } from "qs";

type QsValue =
  | string
  | Record<string, unknown>
  | Array<string | Record<string, unknown>>
  | undefined;

export function stringifyQs(params: object): string {
  return stringify(params, {
    indices: false
  });
}

export function getQueryParamString(val: QsValue): string | undefined {
  if (val === undefined || val === null) {
    return undefined;
  }
  if (typeof val === "string") {
    return val;
  }
  if (Array.isArray(val) && val.length > 0 && typeof val[0] === "string") {
    return val[0];
  }
  return undefined;
}

export function getArrayQueryParamFromParsed(val: QsValue): string[] {
  if (val === undefined || val === null) {
    return [];
  }
  if (typeof val === "string") {
    return [val];
  }
  if (Array.isArray(val)) {
    return val.map(x => (typeof x === "string" ? x : "")).filter(Boolean);
  }
  return [];
}

export function getArrayQueryParam(param: string | string[]): string[] {
  if (!param) {
    return undefined;
  }

  if (isArray(param)) {
    return param;
  }

  return [param];
}

export function parseQueryString<T = Record<string, string>>(
  search: string,
  options?: { ignoreQueryPrefix?: boolean }
): T {
  const s = search.startsWith("?") ? search.slice(1) : search;
  return parseQs(s, options) as T;
}
